module.exports = __webpack_public_path__ + "img/beyond-green-winery.6560db56.jpg";